import { message } from "antd";
import { useAuth } from "navigation/Auth/ProvideAuth";
import CodeVerificationWidget from "components/CodeVerificationWidget/CodeVerificationWidget";

import { REGISTER_WITH } from "config/CONSTANTS";
import {
  ROUTE_BECOME_VENDOR,
  ROUTE_DASHBOARD,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_REGISTER,
  ROUTE_SIGNUP,
} from "navigation/CONSTANTS";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { UpdateCurrentRoot, UpdateQrCodeList } from "redux/actions/appActions";
import { updateUser } from "redux/actions/userActions";
import InputPage from "./InputPage";
import { showChooseTypeDialog } from "pages/HomePage/Layout/ChooseTypeDialog/showChooseTypeDialog";
import { showChooseUserModal } from "./ChooseUserModal/showChooseUserModal";

const LOGIN_PAGES = {
  InputPage: "InputPage",
  ActivationCodePage: "ActivationCodePage",
  InputLocationPage: "InputLocationPage",
};
const pageList = [
  LOGIN_PAGES.InputPage,
  LOGIN_PAGES.ActivationCodePage,
  LOGIN_PAGES.InputLocationPage,
];
function LoginPage(props) {
  const appDataStore = useSelector((x) => x.appDataStore);
  const dispatch = useDispatch();
  const auth = useAuth();
  const [userDetail, setUserDetail] = useState({
    email: "",
    password: ""
  });
  const [isBusy, setIsBusy] = useState(false);
  const [registrationInfo, setRegistrationInfo] = useState(null);
  useEffect(() => {
    dispatch(updateUser({ token: undefined }));
    if (appDataStore?.appInfo?.registration_info) {
      setRegistrationInfo(appDataStore?.appInfo?.registration_info)
    } else {
      setRegistrationInfo(null);
    }
  }, []);

  const onClickLogin = async () => {
    setIsBusy(true)
    auth
      .signin(userDetail)
      .then((res) => {
        setIsBusy(false)
        if (res.result) {
          onSuccessLogin(res);
        } else {
          message.error(res.msg)
        }
      })
      .catch((err) => {
        setIsBusy(false)
        message.error(err);
      });

  };
  const onSuccessLogin = async (info) => {
    if (info.user === undefined || info.msg === undefined) {
      message.error("User doesn't exist!");
      return;
    }
    let tmpObj = { ...info }
    if (tmpObj?.camp_users) {
      let tmpCamps = [...tmpObj.camp_users]
      tmpCamps = tmpCamps.map((x) => {
        return { ...x, checked: false }
      })
      let dlgRes = await showChooseUserModal({ userList: tmpCamps });
      if (dlgRes == null) return;
      tmpObj.camp_users = [...dlgRes]
    }
    dispatch(updateUser(tmpObj));
    props.history.replace(ROUTE_REGISTER);
  };
  const onClickForgot = () => {
    props.history.push(ROUTE_FORGOT_PASSWORD);
  };

  const onClickSignup = () => {
    props.history.push(ROUTE_SIGNUP);
  };
  const onClickRegister = () => {
    props.history.push(ROUTE_REGISTER);
  }
  return (
    <div style={{ color: 'var(--blackColor)', backgroundColor: 'var(--whiteColor)' }}>
      <InputPage
        onClickLogin={onClickLogin}
        onClickForgot={onClickForgot}
        onClickSignup={onClickSignup}
        onClickRegister={onClickRegister}
        userDetail={userDetail}
        setUserDetail={setUserDetail}
        isBusy={isBusy}
        registrationInfo={registrationInfo}
      />
    </div>
  );
}

export default withRouter(LoginPage);
